import Instance from './resource';
import $ from "jquery";
export default {

	GetQueryStringByCode(name, co) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var url = decodeURIComponent(co);
		var r = url.substr(0).match(reg);

		if (r != null) return (r[2]);
		return "";
	},

	GetQueryString(name) {
		console.log("解析");
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var url = decodeURIComponent(window.location.search);
		var r = url.substr(1).match(reg);

		if (r != null) return (r[2]);
		return "";
	},
	safeDown() {
		var tempid = 0;
		var code = this.GetQueryString('code');

		var c = '';
		try {
			c = $.base64.decode(code, 'utf8');
		} catch (error) {
			c = '';
		}
		var typ = this.GetQueryStringByCode('typ', c);
		var platform = this.GetQueryStringByCode('platform', c);
		var from_game = this.GetQueryStringByCode('from_game', c);
		var parm = "{}";
		if (typ == 1) {
			var gameId = this.GetQueryStringByCode('game_id', c);
			tempid = gameId;
			parm = '{"typ":"' + typ + '","game_id":"' + gameId + '","platform":"' + platform + '","from_game":"' + from_game + '"}';
		} else if (typ == 2) {
			var team_id = this.GetQueryStringByCode('team_id', c);
			var inviter_user_id = this.GetQueryStringByCode('inviter_user_id', c);
			//type=2&team_id=1101&inviter_user_id=9929
			parm = '{"typ":"' + typ + '","team_id":"' + team_id + '","inviter_user_id":"' + inviter_user_id + '","platform":"' + platform + '","from_game":"' + from_game + '"}';
		} else {
			var gameId = this.GetQueryString('game_id');
			tempid = gameId;
			if (gameId != "") {
				parm = '{"typ":"1","game_id":"' + gameId + '","platform":"' + platform + '","from_game":"' + from_game + '"}';
			}
		}
		// var clipboard = new Clipboard(".WeChat-bottomBtn");
		/*跳转地址*/
		var data = {};
		data.type = "live"; //表示现在使用线上模式,如果填写"test", 表示测试模式.
		data.params = parm; //注意单引号和双引号的位置
		data.tags = tempid; // 自定义深度链接标签，多个用逗号分隔，【可选】
		linkedme.init("23023c01edb60b3df14b590021fe3e08", {
			type: "live"
		}, function (err, d) {
			if (err) {
				alert('深度链接初始化失败')
			} else {
				linkedme.link(data, function (err, da) {
					if (err) {
						// 生成深度链接失败，返回错误对象err
						alert('深度链接生成失败')
					} else {
						// 生成深度链接成功，深度链接可以通过data.url得到
						//$(".bottomBtn-box").attr('href', da.url);
						window.location = da.url;
						// alert($(".bottomBtn-box").attr('href'));
						// $(".browser-bottomBtn").attr('href', da.url);

					}
				}, false);
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/api/link.js